<template>
    <div class="wallet" >

        <div v-if="renderizado">

            <!-- INCIO TÍTULO PÁGINA -->
            <div class="row align-items-center wallet__tit-page tit_page">
                <div class="col-8 col-md-8 col-lg-8 d-flex align-items-center">
                    <h1>Carteira virtual</h1> 

                    <router-link  
                        v-if="false"  
                        to="/investimentos/carteira-investimento/adicionar-fundos" 
                        title="Adicionar fundos" class="btn btn-primary">
                            <i class="ico-din-4"></i> 
                            Adicionar fundos
                    </router-link>
                    
                </div>
                <div class="col-4 col-md-4 col-lg-4">
                    <div class="back back-hide float-right">
                        <router-link 
                            to="/investimentos/meus-investimentos" 
                            title="Voltar">
                                <i>&nbsp;</i> 
                                voltar
                        </router-link>
                    </div>
                </div>
            </div>
            <!-- FINAL TÍTULO PÁGINA -->

            <!-- INCIO ROW -->
            <div class="row">

                <!-- INCIO COLUNA -->
                <div class="col-12">
                    
                    <wallet-header :saldo="Saldo" />

                    <div class="box-border wallet__extrato">
                        <div class="wallet__extrato--tit">
                            <h2>Minhas transações</h2>
                        </div>

                        
                            <!-- INICIO ACCORDION -->
                            <div class="accordion" id="accordion" :class="(loadingList) ? 'loading-accordion' : ''">
                                <template v-if="loadingList">

                                    <div class="loader"></div>

                                </template>
                                <template v-else>

                                    <!-- INICIO ITEM COLLAPSE -->
                                    <WalletExtratoLista 
                                        :operacoes="Operacoes"
                                    />
                                    <!-- FINAL ITEM COLLAPSE -->
                                </template>
                            </div>
                            <!-- FINAL ACCORDION -->

                        <!-- INICIO PAGINAÇAO -->
                            <Pagination
                                :paginasTotais="this.Paginas"
                                :paginaAtual="this.PaginaAtual"
                                :navigate="mudarPagina"
                            />
                        <!-- FINAL PAGINAÇÃO -->



                    </div>

                </div>

            </div>

        </div>

        <div v-else>
            <div class="row align-items-center wallet__tit-page tit_page">
                <div class="col-8 col-md-8 col-lg-8 d-flex align-items-center">
                    <h1>Carteira virtual</h1> 

                    <router-link  
                        v-if="false"  
                        to="/investimentos/carteira-investimento/adicionar-fundos" 
                        title="Adicionar fundos" class="btn btn-primary">
                            <i class="ico-din-4"></i> 
                            Adicionar fundos
                    </router-link>
                    
                </div>
                <div class="col-4 col-md-4 col-lg-4">
                    <div class="back back-hide float-right">
                        <router-link 
                            to="/investimentos/meus-investimentos" 
                            title="Voltar">
                                <i>&nbsp;</i> 
                                voltar
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="row">
                
                <div class="col-12">
                    
                    <wallet-header :saldo="0.0" />

                    <div class="accordion--btn text-center">
                        <div class="box-border wallet__extrato empty">
                            <h4>
                                Nenhuma transação realizada
                            </h4>
                        </div>
                    </div>

                </div>

            </div>
        </div> 
    </div>
</template>

<style lang="scss" scoped>
    .empty {
        padding: 25vh 30px;
    }

    .loading-accordion {
        height: 590px;
        overflow: hidden;
    }

    .accordion {
        margin-bottom: 15px;
    }

    .loader {
        margin: auto;
        margin-top: 20px;
        border: 12px solid #f3f3f3;
        border-top-color: #41d3bd ;
        border-radius: 50%;
        width: 90px;
        height: 90px;
        animation: spin 1000ms linear infinite;
        position: relative;
        top: 295px;
        margin-top: -45px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>

<script>
    import WalletService from '../../services/api/wallet';
    import Loading from '@/components/Loading';

    import WalletHeader from '../../components/Wallet/WalletHeader.vue';
    import WalletExtratoLista from '../../components/Wallet/WalletExtratoLista.vue';
    import Pagination from '@/components/Pagination'
    import * as mutationTypes from '@/store/mutation-types.js';
    import ApiClient from '../../utils/api-client'

    export default {
        data() {
            return {
                Saldo: 0,
                Operacoes: null,
                PaginaAtual: 1,
                Paginas: 0,
                showModal: false,
                loadingList: false
            }
        },

        components: {
            WalletHeader,
            WalletExtratoLista,
            Loading,
            Pagination
        },

        async created() {
            
            this.listarOperacoes();
        },

        computed: {

            renderizado: function() {

                return this.Operacoes != null;
            }

        },

        methods : {

            async voltar() {
                this.AbrirModal(false);
                await this.listarOperacoes();
            },

            async listarOperacoes() {

                this.loadingList = true;

                const { data } = await WalletService.GetExtratoPaginadoWallet(1);

                this.loadingList = false;

                if(data) {

                    this.Saldo = data.Saldo;
                    this.Paginas = data.Paginas
                    this.Operacoes = data.Operacoes;
                } else {
                    console.warn("error request")
                }
            },

            async mudarPagina(pagina) {

                this.loadingList = true;
         
                const { data } = await WalletService.GetExtratoPaginadoWallet(pagina);
                
                this.loadingList = false;

                this.PaginaAtual = pagina;
                this.Operacoes = data.Operacoes;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/Wallet/Wallet.vue